import { FC, useState } from "react";
import { LoginTextInputProps } from "./types";
import { Color } from "../../../../types";
import { Column, Row } from "../../../../components/containers";
import { JustifyContent } from "../../../../components/containers/types";
import { Text } from "../../../../components/typography";

const COLOR: Color = "#4532a1";

const LoginTextInput: FC<LoginTextInputProps> = ({
  label,
  value,
  setValue,
  Icon,
  inputProps,
  style,
  password = false,
}) => {
  const [focus, setFocus] = useState<boolean>(false);
  const [hover, setHover] = useState<boolean>(false);
  return (
    <Row
      style={{
        ...styles.container,
        ...style,
        background: !(focus || hover) ? "transparent" : COLOR,
      }}
      justifyContent={JustifyContent.Between}
      reverse
      className="transition"
      props={{
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false),
      }}
    >
      <input
        style={styles.input}
        type={password ? "password" : "text"}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        {...inputProps}
      />
      <Column style={styles.info} justifyContent={JustifyContent.Evenly}>
        <Text color="white">{label}</Text>
        <Icon color="white" />
      </Column>
    </Row>
  );
};

export default LoginTextInput;

const styles: Record<string, React.CSSProperties> = {
  container: {
    height: 50,
    borderRadius: 17,
    width: "80%",
    maxWidth: 460,
    border: `1px solid ${COLOR}`,
  },
  input: {
    width: "100%",
    height: "100%",
    background: "transparent",
    color: "white",
    fontSize: 24,
    textAlign: "left",
    marginLeft: 15,
  },
  info: {
    width: 100,
    height: "100%",
  },
};
